// extracted by mini-css-extract-plugin
export default {"container":"style_container__wVVRR","card":"style_card__diwLo"};